import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

import urls from '@admin/shared/constants/urls';

import { environment } from '@environment/environment';

import {
  BillingPlansResponse,
  PlanChangePayload,
  SelectedPlanState,
} from '@shared/models/billing-plan.model';

@Injectable({ providedIn: 'root' })
export class BillingService {
  selectedBillingPlan = new BehaviorSubject<SelectedPlanState | null>(null);

  constructor(private http: HttpClient) {}

  setBillingSubject(selectedPlan: SelectedPlanState) {
    this.selectedBillingPlan.next(selectedPlan);
  }

  getBillingSubject() {
    return this.selectedBillingPlan.asObservable();
  }

  getBillingPlans(): Observable<BillingPlansResponse> {
    const url = environment.backEndServiceURL + urls.PLANS;
    return this.http.get<BillingPlansResponse>(url);
  }

  getPaymentSetup(data: PlanChangePayload, workspace: string) {
    const url =
      environment.backEndServiceURL + urls.PAYMENT_SETUP.replace('{{WORKSPACE_UUID}}', workspace);
    return this.http.post(url, data);
  }

  changePlan(data: PlanChangePayload, workspace: string) {
    const url =
      environment.backEndServiceURL + urls.CHANGE_PLAN.replace('{{WORKSPACE_UUID}}', workspace);
    return this.http.post(url, data);
  }

  getPaymentPlatform(workspaceId: string) {
    const url =
      environment.backEndServiceURL +
      urls.PAYMENT_PALTFORM_DETAILS.replace('{{WORKSPACE_UUID}}', workspaceId);
    return this.http.get(url);
  }

  getPortalURL(workspaceId: string) {
    const url =
      environment.backEndServiceURL +
      urls.PAYMENT_PALTFORM_URL.replace('{{WORKSPACE_UUID}}', workspaceId);
    return this.http.get(url);
  }
}
